export enum FincluOperationStatus {
	IN_PROGRESS = 'in_progress',
	PENDING_REVIEW = 'pending_review',
	PENDING_CLARIFICATION = 'pending_clarification',
	APPROVED = 'approved',
	REJECTED = 'rejected'
}

export interface FincluOperationDeliberation {
	status: FincluOperationStatus;
	deliberation_message: string;
	operator_id: string;
	operator_email?: string;
	transitioned_at: string;
}

export interface UpdateFincluOperationStatusRequest {
	customer_id: string;
	new_status: FincluOperationStatus.APPROVED | FincluOperationStatus.REJECTED;
	deliberation_message: string;
}

export interface UpdateFincluOperationStatusResponse {
	success: boolean;
	customer?: {
		id: string;
		finclu_operation_status: FincluOperationStatus;
		finclu_operation_deliberation_history: FincluOperationDeliberation[];
	};
	error?: string;
}
